import { CASH_RECEIPT_REQUEST, CREATE_CASH_RECEIPT, GET_CASH_RECEIPTS, UPDATE_CASH_RECEIPT, DELETE_CASH_RECEIPT, CASH_RECEIPT_REQUEST_FAILURE,
  CASH_RECEIPT_REQUEST_SUCCESS, GET_CASH_RECEIPTS_PAGE } from '../types';

const initialState = {
  cashReceipts: [],
  cashReceiptsPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const cashReceiptReducer = (state = initialState, action) => {
  switch (action.type) {
    case CASH_RECEIPT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_CASH_RECEIPTS: {      
      return {
        ...state,
        cashReceipts: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_CASH_RECEIPTS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        cashReceiptsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_CASH_RECEIPT: {
      return {
        ...state,
        cashReceipts: [action.payload, ...state.cashReceipts],
        loading: false,
        error: null
      };
    }
    case UPDATE_CASH_RECEIPT: {
      const cashReceiptsData = state.cashReceipts.slice(0);
      const uIndex = cashReceiptsData.findIndex((data) => data.id === action.payload.id);
      cashReceiptsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        cashReceipts: [ ...cashReceiptsData ],
        loading: false,
        error: null
      };
    }
    case DELETE_CASH_RECEIPT: {
      const cashReceipts = state.cashReceipts?.slice(0);
      const index = cashReceipts.findIndex((data) => data.id === action.id);
      
      if (index > -1) {
        cashReceipts.splice(index, 1);
      }
      return {
        ...state,
        cashReceipts: [...cashReceipts],
        loading: false,
        error: null
      }
    }
    case CASH_RECEIPT_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case CASH_RECEIPT_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default cashReceiptReducer;